
<template>
  <div v-if="showFileUploaderList" class="file-uploader--list-container">
    <div
      class="file-uploader-wrapper"
      v-for="attachment in attachmentsRequired"
      :key="attachment.id"
    >
      <fileUploader
        :ref="'uploader-'+attachment.id"
        :id="attachment.id"
        :type="attachment.title"
        :required="attachment.required"
        :ticketId="ticketId"
        :folderName="folderName"
        :useFileUploaderButton="false"
        :setPaginaLoaderCallback="setPaginaLoaderCallback"
        :showError="attachmentsWithErrorsToShow.indexOf(attachment.title) !== -1"
        :onUpdateFilesCallback="
          (selectedFiles) => {
            
            this.updateRequiredFileByType(selectedFiles,attachment.title);
            
          }
        "
      />
    </div>
    <div
      class="file-uploader-wrapper"
      v-for="attachment in attachmentsOptional"
      :key="attachment.id"
    >
      <fileUploader
        :ref="'uploader-'+attachment.id"
        :id="attachment.id"
        :type="attachment.title"
        :required="attachment.required"
        :ticketId="ticketId"
        :folderName="folderName"
        :useFileUploaderButton="false"
        :setPaginaLoaderCallback="setPaginaLoaderCallback"
        :onUpdateFilesCallback="
          (selectedFiles) => {
            this.updateOptionalFileByType(selectedFiles,attachment.title);
           
          }
        "
      />
    </div>
  </div>
</template>

<script>
/** 
Descr: 
Data una answerId controlla se ci sono delle answer_attachment_required.
Se ci sono li suddivide per obbligatori e non obbligatori.
In attachmentsRequired salva le righe con attachment=1, in attachmentOptional gli altri.
In attachmentsRequiredByType vengono salvati i file caricati obbligatori usando come chiave il type, perchè a ogni buca(fileuploader) corrisponde un type e 
di conseguenza una chiamata all'API.
Stesso concetto per attachmentsOptionalByType.
Quando viene creato il ticket, l'id del ticket generato arriva come props qui e innesca l'uploadAll.
 */
import intl from "./intl/intl";
import axios from "axios";
import { apiUrls } from "../../api/apiUrls";
import FileUploader from "../fileUploader/FileUploader.vue";
export default {
  name: "fileUploaderList",
  
  components: {
    fileUploader: FileUploader,
  },
  props: {
    answerId: {
      type: Number,
      default: null,
    },
    ticketId: {
      type: Number,
      default: null,
    },
    extra_request_id: {
      type: Number,
      default: 0,
    },
    setPaginaLoaderCallback: {
      type: Function,
      default: (value) => {
        console.log("FILE UPLOADER LIST LOADER: ", value);
      },
    },
  
    answerDetail: {
      type: Object,
      default: null
    },
    folderName: {
      type: String,
      default: "ticket_attachments",
    },
    onLoadDataStarted: {
      type: Function,
      default: () => {
        console.log("Caricamento dati iniziato");
      },
    },
    attachmentsWithErrorsToShow: {
      type: Array,
      default: () => [],
    },
    onLoadDataEnded: {
      type: Function,
      default: (response, attachmentsRequired, attachmentsOptional) => {
        console.log("Caricamento dati finito");
      },
    },
  },
  mounted() {
    if(this.answerDetail){
       if (
              this.answerDetail.data &&
              this.answerDetail.data.answer_attachment_required &&
              this.answerDetail.data.answer_attachment_required.length > 0
            ) {
              response.data.answer_attachment_required.map((attachment) => {
                if (attachment.required === 1) {
                  this.attachmentsRequired.push(attachment);
                  this.attachmentsRequiredByType[attachment.title] = [];
                } else {
                  this.attachmentsOptional.push(attachment);
                  this.attachmentsOptionalByType[attachment.title] = [];
                }

          
              });
            }
           
           
            
    }
    else if (this.answerId) {
      this.getAnswerDetail();
    }
  },

  data: function () {
    return {
      loader: false,
      intl: intl,
      attachmentsRequired: [],
      attachmentsOptional: [],
      attachmentsRequiredByType: {},
      attachmentsOptionalByType: {},
    };
  },
  methods: {
    checkAttachmentsOnCreateTicket(){
      
      this.attachmentsRequired.map((attachment) => {
        if(this.attachmentsRequiredByType[attachment.title] && this.attachmentsRequiredByType[attachment.title].length === 0){
          this.$refs["uploader-"+attachment.id]["0"].showErrorMessage()
        }else{
          this.$refs["uploader-"+attachment.id]["0"].showGreenBorder()
        }
      })
      this.attachmentsOptional.map((attachment) => {
        this.$refs["uploader-"+attachment.id]["0"].showGreenBorder()
      })
    },
    updateRequiredFileByType(files,type){
      
      this.attachmentsRequiredByType[type] = files;
    },
    updateOptionalFileByType(files,type){
      
      this.attachmentsOptionalByType[type] = files;
    },
    fileObbligatoriDaCaricare(){
        let requiredTypes = Object.keys(this.attachmentsRequiredByType)
        let fileObbligatoriDaCaricare = []
      
        requiredTypes.map((type) => {
          let attachmentsUploaded = this.attachmentsRequiredByType[type]
          if(attachmentsUploaded.length === 0){
            fileObbligatoriDaCaricare.push(type)
          }
        })
        return fileObbligatoriDaCaricare
    },

    //metodo chiamato dal componente padre tramite ref per caricare tutti gli attachments
    uploadAll(ticketId) {
      if(ticketId){
        let fd = null;
      let promises = [];
      let typesRequired = Object.keys(this.attachmentsRequiredByType);
      if (typesRequired && typesRequired.length > 0) {
        typesRequired.map((type) => {
          
          if(this.attachmentsRequiredByType[type].length > 0){
            fd = new FormData();
            this.attachmentsRequiredByType[type].map((file) => {
            if (file.status === 2) {  
              fd.append("file[]", file.file);
            }
          });
          fd.append("type", type);
          fd.append("extra_request_id", this.extra_request_id);
          fd.append("ticket_id", ticketId);
          promises.push(axios.post(apiUrls["create_ticket_attachments"], fd));
          }
          
        });
      }
      let typesOptional = Object.keys(this.attachmentsOptionalByType);
      if (typesOptional && typesOptional.length > 0) {
        typesOptional.map((type) => {
          if(this.attachmentsOptionalByType[type].length > 0){
            fd = new FormData();
          this.attachmentsOptionalByType[type].map((file) => {
            if (file.status === 2) {
              fd.append("file[]", file.file);
            }
          });

          fd.append("type", type);
          fd.append("extra_request_id", this.extra_request_id);
          fd.append("ticket_id", ticketId);
          promises.push(axios.post(apiUrls["create_ticket_attachments"], fd));
          }
          
        });
      }
      this.loader = true;
      Promise.all(promises)
        .then((values) => {
          this.loader = false;
        })
        .catch((error) => {
          this.loader = false;
        });
      }
      
    },

    getAnswerDetail() {
      if (this.answerId) {
       
        this.loader = true;
        this.onLoadDataStarted();
        axios
          .get(apiUrls["answer_detail"] + this.answerId)
          .then((response) => {
           
            if (
              response.data &&
              response.data.answer_attachment_required &&
              response.data.answer_attachment_required.length > 0
            ) {
              response.data.answer_attachment_required.map((attachment) => {
                if (attachment.required === 1) {
                  this.attachmentsRequired.push(attachment);
                  this.attachmentsRequiredByType[attachment.title] = [];
                } else {
                  this.attachmentsOptional.push(attachment);
                  this.attachmentsOptionalByType[attachment.title] = [];
                }

          
              });
            }
           
             
            
           
            
            this.onLoadDataEnded(
              response,
              this.attachmentsRequired,
              this.attachmentsOptional
            );

            this.loader = false;
          })
          .catch((error) => {
            this.onLoadDataEnded(
              error,
              this.attachmentsRequired,
              this.attachmentsOptional
            );

            this.loader = false;
          });
      }
    },
  },
  watch: {
    answerDetail: {
      handler: function (newValue, oldValue) {
       
        if(oldValue === null && newValue !== null){
          if (
              
              newValue.answer_attachment_required &&
              newValue.answer_attachment_required.length > 0
            ) {
              newValue.answer_attachment_required.map((attachment) => {
                if (attachment.required === 1) {
                  this.attachmentsRequired.push(attachment);
                  this.attachmentsRequiredByType[attachment.title] = [];
                } else {
                  this.attachmentsOptional.push(attachment);
                  this.attachmentsOptionalByType[attachment.title] = [];
                }

          
              });
            }
           
        
        }
        
       
      },
      deep: true,
    },
    /* attachmentsRequiredByType: {
      handler: function (newValue, oldValue) {
        
        let requiredTypes = Object.keys(this.attachmentsRequiredByType)
        let fileObbligatoriDaCaricare = []
      
        requiredTypes.map((type) => {
          let attachmentsUploaded = this.attachmentsRequiredByType[type]
          if(attachmentsUploaded.length === 0){
            fileObbligatoriDaCaricare.push(type)
          }
        })
      
   
    
       
      },
      deep: true,
    }, */
    loader: {
      handler: function (newValue, oldValue) {
        if (oldValue !== newValue) {
          this.setPaginaLoaderCallback({ fileUploaderList: newValue });
        }
      },
      immediate: true,
    },
   
  },
  computed: {
    showFileUploaderList: function () {
      return (
        this.answerDetail || 
        (this.answerId &&
        (this.attachmentsRequired.length > 0 ||
          this.attachmentsOptional.length > 0)
      ));
    },
    
  },
};
</script>
